export default __webpack_public_path__ + "static/media/output-onlinegiftools.d2c27ca3.gif";